// extracted by mini-css-extract-plugin
export default {"appBackground":"AppCard_appBackground__FTOlY","card":"AppCard_card__UkxVE"};